export const pinMessageExtension = "ve0mpe";
export const unpinMessageExtension = "CeTzid";
export default {pinMessageExtension,unpinMessageExtension};